<template>
  <div>
    <!-- d-flex などのユーティリティクラスは Vuetify 3 でも継続利用可能 -->
    <div class="d-flex align-center">
      <h2 class="text-h5 font-weight-bold">運営ユーザー設定</h2>
      <v-spacer />
      <!-- v-btn: depressed は variant="flat" に変更 -->
      <v-btn color="primary" variant="flat" @click="create">
        <v-icon start>mdi-plus</v-icon>
        新規作成
      </v-btn>
    </div>

    <!-- v-progress-linear: indeterminate はそのまま -->
    <v-progress-linear v-if="isLoading" indeterminate color="primary" />

    <!-- v-simple-table は v-table に名称変更 -->
    <v-table class="mt-4">
      <thead>
        <tr>
          <th class="text-left">氏名</th>
          <th class="text-left">氏名（カナ）</th>
          <th class="text-left">メールアドレス</th>
          <th class="text-left">管理者</th>
          <th class="text-left">編集</th>
          <th class="text-left"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in users" :key="item.userId">
          <td>{{ item.lastName }}{{ item.firstName }}</td>
          <td>{{ item.lastNameKana }}{{ item.firstNameKana }}</td>
          <td>{{ item.email }}</td>
          <td>
            <v-chip v-if="item.isAdmin" label size="small" color="secondary">
              管理者
            </v-chip>
            <div v-else>-</div>
          </td>
          <td>
            <!-- Vuetify 3 の v-btn は outlined の代わりに variant="outlined" -->
            <v-btn
              :to="`/admin-user/edit/${item.userId}`"
              color="primary"
              variant="outlined"
              size="small"
            >
              編集
            </v-btn>
          </td>
          <td>
            <v-icon v-if="item.isDisabled" size="small" color="error">
              mdi-block-helper
            </v-icon>
          </td>
        </tr>
      </tbody>
    </v-table>
  </div>
</template>

<script lang="ts">
import LocalDataService from "@/service/LocalDataService";
import { userModule } from "@/store/dataModule/userModule";
import { OperationUserResponse } from "chaild-api/lib";
import { defineComponent } from "vue";
export default defineComponent({
  async mounted() {
    await this.listUsers();
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    users: function (): OperationUserResponse[] {
      return userModule.users;
    },
  },

  methods: {
    async listUsers() {
      this.isLoading = true;
      const companyId = LocalDataService.getCompanyId();
      if (companyId) {
        await userModule.listUsers({
          companyId: companyId,
        });
      }
      this.isLoading = false;
    },
    create() {
      this.$router.push({ name: "AdminUserEdit" });
    },
  },
});
</script>
